var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-data-table',{attrs:{"p-headers":_vm.headers,"p-title":"Endereços","p-read-link":"address.read.one","p-create-link":"address.create","p-name":"address"}})}
var staticRenderFns = []

export { render, staticRenderFns }